import { render, staticRenderFns } from "./commodityPigCycle.vue?vue&type=template&id=6788e43d&scoped=true&"
import script from "./commodityPigCycle.vue?vue&type=script&lang=js&"
export * from "./commodityPigCycle.vue?vue&type=script&lang=js&"
import style0 from "./commodityPigCycle.vue?vue&type=style&index=0&id=6788e43d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788e43d",
  null
  
)

export default component.exports